import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FieldType } from '../../../core';
var FormlyFieldInput = (function (_super) {
    tslib_1.__extends(FormlyFieldInput, _super);
    function FormlyFieldInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormlyFieldInput.prototype, "type", {
        get: function () {
            return this.to.type || 'text';
        },
        enumerable: true,
        configurable: true
    });
    return FormlyFieldInput;
}(FieldType));
FormlyFieldInput = tslib_1.__decorate([
    Component({
        selector: 'formly-field-input',
        template: "\n    <input [type]=\"type\" [formControl]=\"formControl\" class=\"form-control\"\n      [formlyAttributes]=\"field\" [ngClass]=\"{'form-control-danger': showError}\">\n    ",
    })
], FormlyFieldInput);
export { FormlyFieldInput };
//# sourceMappingURL=input.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/input.js
// module id = 773
// module chunks = 3